import { useState, useEffect } from 'react';
import axios from "axios";
import { locationsAction, categoryAction, paginationAction, googlemapcenteraction } from './actions';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Country, State, City }  from 'country-state-city';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
const baseUrl = `/wp-json/wp/v2`;
const catBaseUrl = `/wp-json`;
const StoreLocations = () => {
    var SiteData = useSelector(state => state.SiteData);
    const countStores = SiteData.countStores;
    const hidepagination = SiteData.hidepagination;
    const noOfStores = SiteData.storesperload ? parseInt(SiteData.storesperload) : 20;
    var dispatch = useDispatch();
    var pagination = parseInt(useSelector(state => state.paginationOffset));
    var selectedCatId = useSelector(state => state.CategoryChoosed);
    pagination = pagination - 1;
    pagination = (pagination < 0 ) ? 0 : pagination;
    pagination = pagination * noOfStores;
    var url = ''
    if ( selectedCatId ) {
        if ( !hidepagination ) {
            url = `${baseUrl}/react-store-locator?rsl_categories=${selectedCatId}&per_page=${noOfStores}&offset=${pagination}`;
        } else {
            url = `${baseUrl}/react-store-locator?rsl_categories=${selectedCatId}&per_page=${countStores}`;
        }
    } else {
        if ( !hidepagination ) {
            url = `${baseUrl}/react-store-locator?per_page=${noOfStores}&offset=${pagination}`;
        } else {
            url = `${baseUrl}/react-store-locator?per_page=${countStores}`;
        }
    }
    useEffect(() => {
        axios.get(url)
        .then(resp => {
            if ( resp.status === 200 ) {
                for (var key in resp.headers) {
                    if (resp.headers.hasOwnProperty(key)) {
                        if ( 'x-wp-total' === key ) {
                            var allRecords = resp.headers[key];
                        }
                        if ( 'x-wp-totalpages' === key ) {
                            var totalPages = resp.headers[key];
                        }
                    }
                }
                dispatch(locationsAction({data:resp.data, allRecords: allRecords, totalPages:totalPages}));
            }
        }).catch( ( error ) => {
        } )
    }, [url, dispatch])
}
var Categories = () => {
    var SiteData = useSelector(state => state.SiteData);
    const hidepagination = SiteData.hidepagination;
    const noOfStores = SiteData.storesperload ? parseInt(SiteData.storesperload) : 20;
    const countStores = SiteData.countStores;
    var dispatch = useDispatch();
    const [ term, setTerm ] = useState([]);
    const handleChange = ( e ) => {
        var catActiveColor = SiteData.cat_active_color ? SiteData.cat_active_color : '#ccc';
        var catActiveTextColor = SiteData.cat_active_text_color ? SiteData.cat_active_text_color : '#000';
        var category_ids = e.target.value;
        if ( 'checkbox' === e.target.type ) {
            if ( e.target.checked ) {
                e.target.closest('label').style.color = catActiveTextColor;
                e.target.closest('label').style.background = catActiveColor;
                term.push(category_ids);
                setTerm(term);
            } else {
                var index = term.indexOf(category_ids);
                if (index > -1) {
                    term.splice(index, 1);
                    setTerm(term);
                }
                var catColor = SiteData.cat_color ? SiteData.cat_color : '#efefef';
                var catTextColor = SiteData.cat_text_color ? SiteData.cat_text_color : '#000';
                e.target.closest('label').style.color=catTextColor;
                e.target.closest('label').style.background=catColor;
            }
            category_ids = term.join(',');
        } else {
            const { target: { value } } = e;
            setTerm( typeof value === 'string' ? value.split(',') : value );
        }
        dispatch(paginationAction(0));
        var url = '';
        if ( category_ids.length === 0 ) {
            dispatch(categoryAction(false));
            if ( '' === hidepagination ) {
                url = `${baseUrl}/react-store-locator?per_page=${noOfStores}&offset=0`;
            } else {
                url = `${baseUrl}/react-store-locator?per_page=${countStores}`;
            }
        } else {
            if ( '' === hidepagination ) {
                url = `${baseUrl}/react-store-locator?rsl_categories=${category_ids}&per_page=${noOfStores}&offset=0`;
            } else {
                url = `${baseUrl}/react-store-locator?rsl_categories=${category_ids}&per_page=${countStores}`;
            }
            dispatch(categoryAction(category_ids));
        }
        axios.get(url).then(resp => {
            if ( resp.status === 200 ) {
                for (var key in resp.headers) {
                    if (resp.headers.hasOwnProperty(key)) {
                        if ( 'x-wp-total' === key ) {
                            var allRecords = resp.headers[key];
                        }
                        if ( 'x-wp-totalpages' === key ) {
                            var totalPages = resp.headers[key];
                        }
                    }
                }
                dispatch(locationsAction({data:resp.data, allRecords: allRecords, totalPages:totalPages}));
            }
        });
    }
    const [data, setData] = useState([]);
    var mapId = SiteData.map_id ? SiteData.map_id : '';
    useEffect(() => {
        axios.get(`${catBaseUrl}/rsl-categories/get-taxonomies?id=${mapId}`).then(resp => {
            if ( resp.status === 200 ) {
                setData(resp.data);
            } else {
                setData([]);
            }
        });
    }, [mapId]);
    var all_cats_label = SiteData.label_categories ? SiteData.label_categories : 'All Categories';
    var catColor = SiteData.cat_color ? SiteData.cat_color : '#efefef';
    var catTextColor = SiteData.cat_text_color ? SiteData.cat_text_color : '#000';
    return (
        <Grid container>
            {'tabs' === SiteData.dropdownstyle ? data ? data.map(( term, index ) =>
                <label key={index} className="rslCategoriesTabs" style={{background:catColor, color:catTextColor}}>
                <input type="checkbox" value={term.id} onClick={handleChange} />{term.name}
                </label>) : '' :
            <FormControl className="categories_dropdown">
                <InputLabel id="demo-simple-select-label">{all_cats_label}</InputLabel>
                <Select labelId="demo-simple-select-label" multiple value={term} id="demo-simple-select" label={all_cats_label} onChange={handleChange}>
                    { data ? data.map(( term, index ) => <MenuItem key={index} value={term.id}>{term.name}</MenuItem>) : '' }
                </Select>
            </FormControl>}
        </Grid>
    )
}
const FullAddress = () => {
    var dispatch = useDispatch();
    const SiteData = useSelector(state => state.SiteData);
    var [country, setcountry] = useState('');
    var [countrystates, setcountrystates] = useState([]);
    var [statecities, setstatecities] = useState([]);
    const countryChanged = ( e, v ) => {
        setcountry(v.code);
        const countrystates = State.getStatesOfCountry(v.code).map((option) => {
            return({ label:option.name, code:option.isoCode});
        });
        setcountrystates(countrystates);
    }
    const stateChanged = ( e, v ) => {
        const statecities = City.getCitiesOfState(country, v.code).map((option) => {
            return({ label:option.name, latitude:option.latitude, longitude:option.longitude});
        });
        setstatecities(statecities);
    }
    const cityChanged = ( e, v ) => {
        dispatch(googlemapcenteraction({ init: true, coordinates: { lat: parseFloat(v.latitude), lng: parseFloat(v.longitude) } }));
    }
    const restrictcountries = SiteData.restrictcountries ? SiteData.restrictcountries : [];
    var allcountries = Country.getAllCountries().map(( option ) => {
        if ( restrictcountries.length > 0 && restrictcountries.includes(option.isoCode) ) {
            return({ label:option.name, code:option.isoCode});
        } else if ( restrictcountries.length === 0 ) {
            return({ label:option.name, code:option.isoCode});
        }
    });
    function filtercountries( country ) {
        if ( country === undefined) {
            return;
        }
        return country;
    }
    const citiesLabel = SiteData.citiesLabel ? SiteData.citiesLabel : 'City';
    const statesLabel = SiteData.statesLabel ? SiteData.statesLabel : 'State';
    const countriesLabel = SiteData.countriesLabel ? SiteData.countriesLabel : 'Country';
    allcountries = allcountries.filter(filtercountries);
    return(
        <Box sx={{ flexGrow: 1 }} className="rslCountryStateCity">
            <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                    <Autocomplete className="rslCountries" options={allcountries}
                    onChange={(event, newValue) => {
                        countryChanged(event, newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label={countriesLabel} />} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Autocomplete className="rslStates" options={countrystates}
                    onChange={(event, newValue) => {
                        stateChanged(event, newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label={statesLabel} />} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Autocomplete className="rslCities" options={statecities}
                    onChange={(event, newValue) => {
                        cityChanged(event, newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label={citiesLabel} />} />
                </Grid>
            </Grid>
        </Box>
    )
}
export { Categories, FullAddress };
export default StoreLocations;